import React, { useState, useEffect } from "react";
import {
  Box,
  Autocomplete,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { TIMEZONE_OPTIONS } from "./const/timezones";

interface TimezoneSelectorProps {
  value: string;
  onChange: (newValue: string) => void;
}

const TimezoneSelector: React.FC<TimezoneSelectorProps> = ({
  value,
  onChange,
}) => {
  const [mode, setMode] = useState<"local" | "custom">("custom");

  useEffect(() => {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (value === detected) {
      setMode("local");
    } else {
      setMode("custom");
    }
  }, [value]);

  const handleModeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newMode = event.target.value as "local" | "custom";
    setMode(newMode);
    if (newMode === "local") {
      const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
      onChange(detected);
    }
  };

  const handleCustomChange = (
    event: React.SyntheticEvent,
    newValue: { label: string; value: string } | null
  ) => {
    if (newValue) {
      onChange(newValue.value);
    }
  };

  return (
    <Box>
      <RadioGroup row value={mode} onChange={handleModeChange}>
        <FormControlLabel
          value="local"
          control={<Radio />}
          label="Local Time"
        />
        <FormControlLabel value="custom" control={<Radio />} label="Custom" />
      </RadioGroup>
      {mode === "custom" && (
        <Autocomplete
          options={TIMEZONE_OPTIONS}
          getOptionLabel={(option) => option.label}
          value={
            TIMEZONE_OPTIONS.find((option) => option.value === value) || null
          }
          onChange={handleCustomChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Timezone"
              variant="outlined"
              helperText="Choose your preferred timezone (applied on Save)"
            />
          )}
          sx={{ mt: 2 }}
        />
      )}
    </Box>
  );
};

export default TimezoneSelector;
